module.exports = __webpack_public_path__ + "static/media/virtual-product-icon.2dc7c27a.png";